import React from 'react';

interface BrandLogoProps {
  inverse?: boolean;
  compact?: boolean;
}

/**
 * Lockup de marca. El nombre es Peluqueria.AI y el sufijo `.AI` va en el color
 * de acento, el mismo tratamiento que usan el panel y la splash de la app
 * (server/plugins/platform-shell.ts en el repo reserva-ya).
 */
const BrandLogo: React.FC<BrandLogoProps> = ({
  inverse = false,
  compact = false,
}) => (
  <span
    className={`salon-lockup${inverse ? ' salon-lockup--inverse' : ''}${
      compact ? ' salon-lockup--compact' : ''
    }`}
    aria-label="Peluqueria.AI"
  >
    <span className="salon-word" aria-hidden="true">
      <span className="salon-word__salon">Peluqueria</span>
      <span className="salon-word__ya">.AI</span>
    </span>
  </span>
);

export default BrandLogo;
